import { cn } from 'cn';
import { useTranslation } from 'react-i18next';

type P = {
  readonly isActive: boolean;
} & ComponentStyling;

/**
 * ActiveStateIndicator
 *
 * Displays a styled indicator of the active state of an entity (user, site, cost center) in a table.
 */
export const ActiveStateIndicator = ({ className, isActive, style }: P) => {
  const { t } = useTranslation('analytics');

  return (
    <div
      className={cn('flex size-full items-center justify-center', className)}
      style={style}
    >
      <div
        className={cn(
          'flex min-w-16 shrink-0 items-center gap-1.5 rounded-full pr-3 pl-2.5 text-sm leading-7 text-tiga-text-default',
          isActive ? 'bg-tiga-semantic-success/21' : 'bg-tiga-surface-lighter',
        )}
      >
        <div
          className={cn(
            'size-3 rounded-full bg-blend-multiply',
            isActive ? 'bg-tiga-semantic-success' : 'bg-tiga-text-default',
          )}
        />
        {isActive ? t(($) => $.usage.isActive) : t(($) => $.usage.isInactive)}
      </div>
    </div>
  );
};
